import React from "react";
import Navbar from '../components/navbar';
import SearchBar from '../components/searchBar';
function Home(){
    return(
<div className="Home">
<Navbar />
<SearchBar />

</div>
    )
}

export default Home;